'use client'
import { useUpsellCountdown } from '@/features/upsell/hooks'
import { TypePopup } from '@/store/upsell'
import { Typography } from '@mui/material'
import { useEffect } from 'react'

interface IExpiredTransactionProps {
  expiryTime: string | Date // Thời gian hết hạn (ISO string hoặc Date object)
  onExpired?: () => void // Callback khi hết thời gian
}

export const ExpiredTransaction = ({ expiryTime, onExpired }: IExpiredTransactionProps) => {
  // Tính số giây còn lại từ hiện tại đến thời gian hết hạn
  // const initialSeconds = useMemo(() => {
  //   const now = new Date().getTime()
  //   const expiry = new Date(expiryTime).getTime()
  //   const diffInSeconds = Math.floor((expiry - now) / 1000)
  //   return diffInSeconds > 0 ? diffInSeconds : 0
  // }, [expiryTime])

  // const { count, start } = useCountdownV2({
  //   initialValue: initialSeconds,
  //   onComplete: onExpired,
  // })

  // Sử dụng custom hook để quản lý countdown
  const { expireAfter: count } = useUpsellCountdown({
    type: TypePopup.PAYMENT,
    expireDate: expiryTime as string,
    onComplete: onExpired,
  })

    // Kiểm tra lại khi tab được focus (xử lý browser throttling)
    useEffect(() => {
      const handleVisibilityChange = () => {
        if (!document.hidden) {
          // Nếu đã hết hạn trong lúc tab không focus
          if (count === 0 && onExpired) {
            onExpired()
          }
        }
      }
  
      document.addEventListener('visibilitychange', handleVisibilityChange)
  
      return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
      }
    }, [count, onExpired])

  const minutes = Math.floor(count / 60)
  const seconds = count % 60

  // useEffect(() => {
  //   start()
  // }, [start])

  return (
    <Typography
      fontWeight={600}
      sx={{ fontSize: { xs: '1.5rem', md: '2rem' }, lineHeight: 1, color: '#F04438' }}
    >
      {minutes?.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
    </Typography>
  )
}
